import React, { lazy, Suspense } from "react";
import classes from "./Header.module.css";
import getIcons from "../../../SolarGikLib/icons/Icons";
import { GeneralIcons, IconCategory } from "../../../SolarGikLib/icons/IconsModels";
import UserOptionDropdownMenu from "../../banner/UserOptionDropdownMenu";

const ChatWidget = lazy(() =>
  import("../../chat/components/ChatWidget").then((module) => ({ default: module.ChatWidget }))
);

interface IHeaderProps {
  isAiChatEnabled: boolean;
}

const Header: React.FC<IHeaderProps> = ({ isAiChatEnabled }) => {
  const SolarGikLogoIcon = getIcons(GeneralIcons.HeaderSolargikLogo, IconCategory.General);
  const UserIcon = getIcons(GeneralIcons.UserIcon, IconCategory.General);
  return (
    <div className={classes.header}>
      <div className={classes.leftItems}>
        <SolarGikLogoIcon />
        <span className={classes["page-name"]}>{"Multisite dashboard"}</span>
      </div>

      <div className={classes.rightItems}>
        {isAiChatEnabled && (
          <div className={classes["chat-widget"]}>
            <Suspense fallback={null}>
              <ChatWidget />
            </Suspense>
          </div>
        )}
        <UserOptionDropdownMenu icon={UserIcon} addSingleSiteMenuItems={false} />
      </div>
    </div>
  );
};
export default Header;
